import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container fill-height pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "ma-0 pa-0"
  }, [_c('core-n20Card', {
    staticStyle: {
      "height": "80px"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('custom-multi-search', {
    staticClass: "mr-2",
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "operator": _vm.searchOperator,
      "defaultSearchType": {
        param: 'quickSearch',
        text: 'Quick search'
      },
      "showOperatorDropdown": "",
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  }), _vm.isMobile ? _c('span', [_c('core-account-filter', {
    attrs: {
      "selected": _vm.initialAccounts,
      "multiple": "",
      "iconOnly": ""
    },
    on: {
      "change": accounts => {
        _vm.selectedAccounts = accounts.map(a => a.id);
      },
      "ready": function ($event) {
        _vm.accountFilterReady = true;
      }
    }
  })], 1) : _c('span', [_c('core-account-filter', {
    attrs: {
      "selected": _vm.initialAccounts,
      "multiple": ""
    },
    on: {
      "change": accounts => {
        _vm.selectedAccounts = accounts.map(a => a.id);
      },
      "ready": function ($event) {
        _vm.accountFilterReady = true;
      }
    }
  })], 1)], 1)])], 1)], 1), _c('core-dtwin-map-instance', {
    ref: "mapInstance",
    staticStyle: {
      "height": "calc(100% - 80px)"
    },
    attrs: {
      "markerItems": _vm.markerItems,
      "clusters": _vm.dtwinClusters,
      "polygons": _vm.polygons,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "cameraObj": _vm.camera,
      "gradientPolygonColours": _vm.gradientPolygonColours,
      "selectedCluster": _vm.selectedCluster,
      "hideStatelessPolygons": !!_vm.selectedStateKey && _vm.hideStatelessPolygons,
      "hideStateHistoryBefore": new Date(_vm.historyFrom * 1000).toISOString(),
      "detailsGetApiMethod": "virtualDeviceGet",
      "detailsBaseLink": "virtual-devices"
    },
    on: {
      "map-moved": e => _vm.loadTree(e.bounds, e.stateKey, e.twinTag),
      "getClusterContent": _vm.getClusterContent
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function () {
        return [_c('div', {
          staticClass: "mapLayerControl",
          staticStyle: {
            "z-index": "5"
          }
        }, [_c(VRow, {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex",
            "flex-direction": "row",
            "justify-content": "flex-start",
            "align-items": "center"
          },
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VBtn, {
          class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "title": _vm.$i18n_t('Common.back'),
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.go(-1);
            }
          }
        }, [_c(VIcon, [_vm._v("fal fa-arrow-alt-left")])], 1)], 1), _vm.buildingFloorList && _vm.buildingFloorList.length > 1 ? _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VMenu, {
          attrs: {
            "open-on-hover": "",
            "close-delay": "200",
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VBtn, _vm._g({
                class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
                attrs: {
                  "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
                  "color": _vm.color,
                  "icon": "",
                  "info": "",
                  "fab": "",
                  "text": ""
                }
              }, on), [_c(VIcon, [_vm._v("fal fa-layer-plus")])], 1)];
            }
          }], null, false, 3162116487)
        }, [_c(VList, _vm._l(_vm.buildingFloorList, function (floor, index) {
          return _c(VListItem, {
            key: index
          }, [_c(VBtn, {
            attrs: {
              "outlined": _vm.indoorFloorDtwinId === floor.id,
              "elevation": _vm.indoorFloorDtwinId === floor.id ? 2 : 1,
              "plain": ""
            },
            on: {
              "click": function ($event) {
                _vm.indoorFloorDtwinId = floor.id;
              }
            }
          }, [_vm._v("\n                    " + _vm._s(floor.floorNumber) + "\n                  ")])], 1);
        }), 1)], 1)], 1) : _vm._e(), _vm.floorList.length ? _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VMenu, {
          attrs: {
            "close-on-content-click": false,
            "min-width": "300",
            "max-width": "300",
            "nudge-left": "12",
            "offset-x": "",
            "bottom": "",
            "right": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VBtn, _vm._g({
                class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
                attrs: {
                  "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settings'),
                  "color": _vm.color,
                  "icon": "",
                  "info": "",
                  "fab": "",
                  "text": ""
                }
              }, on), [_c(VIcon, [_vm._v("fal fa-layer-group")])], 1)];
            }
          }], null, false, 2915292552)
        }, [_c(VCard, [_c(VContainer, {
          staticClass: "pa-6",
          attrs: {
            "fluid": ""
          }
        }, [_c(VRow, {
          staticStyle: {
            "min-width": "0"
          }
        }, [_c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorSwitcher')) + "\n                      ")]), _c(VSwitch, {
          attrs: {
            "true-value": true,
            "color": _vm.color,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.indoorEnable'),
            "hide-details": ""
          },
          model: {
            value: _vm.indoorEnabled,
            callback: function ($$v) {
              _vm.indoorEnabled = $$v;
            },
            expression: "indoorEnabled"
          }
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.types.building')) + " " + _vm._s(_vm.$i18n_t('Common.filter')) + "\n                      ")]), _c(VSelect, {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "items": _vm.buildingList,
            "disabled": !_vm.indoorEnabled,
            "item-text": "title",
            "item-value": "id",
            "hide-details": "",
            "dense": "",
            "solo": ""
          },
          model: {
            value: _vm.indoorBuildingId,
            callback: function ($$v) {
              _vm.indoorBuildingId = $$v;
            },
            expression: "indoorBuildingId"
          }
        })], 1), _c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c(VDivider, {
          staticClass: "mb-4"
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor')) + "\n                      ")]), _c(VSelect, {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "items": (_vm.groupedFloors[`${_vm.indoorBuildingId}`] || {}).floors || [],
            "disabled": !_vm.indoorEnabled,
            "item-text": "title",
            "item-value": "id",
            "hide-details": "",
            "dense": "",
            "solo": ""
          },
          model: {
            value: _vm.indoorFloorDtwinId,
            callback: function ($$v) {
              _vm.indoorFloorDtwinId = $$v;
            },
            expression: "indoorFloorDtwinId"
          }
        }), _c(VDivider, {
          staticClass: "mt-4"
        })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c(VMenu, {
          attrs: {
            "close-on-content-click": false,
            "min-width": "300",
            "max-width": "300",
            "nudge-left": "12",
            "offset-x": "",
            "bottom": "",
            "right": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VBtn, _vm._g({
                class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
                attrs: {
                  "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settings'),
                  "color": _vm.color,
                  "icon": "",
                  "info": "",
                  "fab": "",
                  "text": ""
                }
              }, on), [_c(VIcon, [_vm._v("fal fa-cogs")])], 1)];
            }
          }])
        }, [_c(VCard, [_c(VContainer, {
          staticClass: "pa-6",
          attrs: {
            "fluid": ""
          }
        }, [_c(VRow, {
          staticStyle: {
            "min-width": "0"
          }
        }, [_c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [!_vm.isMobile ? _c('div', {
          staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.settings')) + "\n                      ")]) : _vm._e(), _c(VSwitch, {
          attrs: {
            "true-value": true,
            "color": _vm.color,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settingsPersist'),
            "hide-details": ""
          },
          model: {
            value: _vm.persistSettings,
            callback: function ($$v) {
              _vm.persistSettings = $$v;
            },
            expression: "persistSettings"
          }
        }), !_vm.isMobile ? _c('div', {
          staticClass: "mt-2 text-center text-caption"
        }, [_vm._v("\n                        " + _vm._s(_vm.persistSettings ? _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settingsPersistText') : _vm.$i18n_t('DigitalTwin.DigitalTwin.map.settingsDiscardText')) + "\n                      ")]) : _vm._e()], 1), _c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c(VDivider, {
          staticClass: "mb-4"
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.stateKeySelection')) + "\n                      ")]), _c(VSelect, {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            "items": _vm.stateKeySelectionItems,
            "item-text": "text",
            "item-value": "value",
            "hide-details": "",
            "dense": "",
            "solo": ""
          },
          model: {
            value: _vm.selectedStateKey,
            callback: function ($$v) {
              _vm.selectedStateKey = $$v;
            },
            expression: "selectedStateKey"
          }
        }), _c('div', {
          staticClass: "mt-4 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.maximumStateAge')) + "\n                      ")]), _c('core-date-time-picker-flat-textbased', {
          staticClass: "mt-0",
          attrs: {
            "disabled": !_vm.selectedStateKey,
            "from": _vm.historyFrom,
            "alternateInitialText": _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.plainMonths', 2, {
              n: 2
            }),
            "plainDates": "",
            "dense": ""
          },
          on: {
            "date:picked": _vm.handleHistoryFromPicked
          }
        }), _vm.selectedStateKey ? [_c(VSwitch, {
          attrs: {
            "true-value": true,
            "color": _vm.color,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.hideStatelessPolygons'),
            "hide-details": ""
          },
          model: {
            value: _vm.hideStatelessPolygons,
            callback: function ($$v) {
              _vm.hideStatelessPolygons = $$v;
            },
            expression: "hideStatelessPolygons"
          }
        }), !_vm.isMobile ? _c('div', {
          staticClass: "mt-2 text-center text-caption"
        }, [_vm._v("\n                          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.hideStatelessPolygonsText')) + "\n                        ")]) : _vm._e()] : _vm._e(), _c('div', {
          staticClass: "mt-4 mb-0 text-center text-body-2 text-uppercase sidebar-filter"
        }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.useGradientPolygonColoursGrad')) + "\n                      ")]), _c(VSwitch, {
          staticClass: "mt-1 pt-1",
          attrs: {
            "true-value": true,
            "value": _vm.gradientPolygonColours,
            "input-value": _vm.gradientPolygonColours,
            "color": _vm.color,
            "disabled": _vm.selectedStateKey === null,
            "label": _vm.gradientPolygonColours ? _vm.$i18n_t('DigitalTwin.DigitalTwin.map.useGradientPolygonColoursGrad') : _vm.$i18n_t('DigitalTwin.DigitalTwin.map.useGradientPolygonColoursAbs'),
            "hide-details": ""
          },
          model: {
            value: _vm.gradientPolygonColours,
            callback: function ($$v) {
              _vm.gradientPolygonColours = $$v;
            },
            expression: "gradientPolygonColours"
          }
        }), _c(VDivider, {
          staticClass: "mt-4"
        })], 2), _c(VCol, {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c(VBtn, {
          attrs: {
            "small": ""
          },
          on: {
            "click": _vm.resetDefaults
          }
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.reset')))])], 1)])], 1)], 1)], 1)], 1)], 1)])], 1)];
      },
      proxy: true
    }, {
      key: "regularMarker",
      fn: function (item) {
        return [item.marker.imageId ? [_c('div', {
          staticClass: "markerIcon",
          style: `background-image: url('${_vm.mapMarkerIconUrl(item.marker.imageId)}')`
        })] : [_c(VIcon, {
          class: `markerPin status-color-${item.marker.health !== null ? item.marker.health.state : 'unknown'}`
        }, [_vm._v("\n          fal fa-" + _vm._s(item.marker.faIcon ? item.marker.faIcon : 'map-marker-alt') + "\n        ")]), _c('span', {
          class: `markerPinTitle status-color-${item.marker.health !== null ? item.marker.health.state : 'unknown'}`
        }, [_vm._v("\n          " + _vm._s(item.marker.title) + "\n        ")])]];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };